const location = window.location
const protocol = location.protocol
console.log(protocol, 'location protocol')

// 统一登录接口地址
const switchSsoLinkApi = ((value) => {
  let str = ''
  switch (value) {
    case 'https:':
      str = 'https://api.sso.53tech.cn/api/'
      break;
    case 'http:':
      str = 'http://dev.api.sso.53tech.cn/api/'
      break;
  }
  return str
})

// 统一登录地址
const switchSsoLink = ((value) => {
  let str = ''
  switch (value) {
    case 'https:':
      str = 'https://sso.53tech.cn'
      break;
    case 'http:':
      str = 'http://dev.sso.53tech.cn'
      break;
  }
  return str
})

module.exports = {
  // 统一登录接口地址 https://api.sso.53tech.cn/api http://82.157.190.31:45521/api/ http://90d333b.r7.cpolar.top
  // 统一登录地址 https://sso.53tech.cn http://192.168.0.104:8080  http://43.128.92.74:83
  ssoLinkApi: switchSsoLinkApi(protocol),
  ssoLink: switchSsoLink(protocol)
}



// WEBPACK FOOTER //
// ./src/settings.js